import script from "./TabsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsPage.vue?vue&type=script&setup=true&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=420b1d2a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420b1d2a"]])

export default __exports__